import { useSyncExternalStore } from "react";

const QUERY = "(max-width: 767px)";

function subscribe(callback: () => void) {
  const mql = window.matchMedia(QUERY);
  mql.addEventListener("change", callback);
  return () => mql.removeEventListener("change", callback);
}

function getSnapshot() {
  return window.matchMedia(QUERY).matches;
}

/**
 * True below the 768px breakpoint — the same cutoff as Tailwind's `md`,
 * so JS forks and `max-md:` styles always agree.
 */
export function useIsMobile() {
  return useSyncExternalStore(subscribe, getSnapshot);
}
